import { makeAutoObservable } from "mobx";
import api, {
  PostAuthRegisterParameters,
  PostAuthLoginParameters,
  PostAuthSendVerificationCodeParameters,
  PostAuthSendVerificationCodeRes,
} from "../api";
import { createRequestStatus, handleRequest } from "../toll/toolRequestStatus";
import { message } from "antd";
import i18n from "../I18n/index"; // 假设你已经初始化i18n

class AuthStore {
  loginStatus = createRequestStatus();
  registerStatus = createRequestStatus();
  sendCodeStatus = createRequestStatus();
  logoutStatus = createRequestStatus();
  loggedIn = false;
  sendCodeData?: PostAuthSendVerificationCodeRes
  registerSuccess = false;

  constructor () {
    makeAutoObservable(this);
  }

  register = async (params: PostAuthRegisterParameters) => {
    await handleRequest(
      this.registerStatus,
      () => api.PostAuthRegister(params),
      () => {
        this.registerSuccess = true;
      },
      i18n.t("auth.register_failed")
    );
  };

  resetRegister() {
    this.registerSuccess = false;
  }

  resetLoginStatus() {
    this.loginStatus = createRequestStatus()
  }

  resetSendCodeStatus() {
    this.sendCodeStatus = createRequestStatus()
  }

  sendVerificationCode = async (params: PostAuthSendVerificationCodeParameters) => {
    await handleRequest<PostAuthSendVerificationCodeRes>(
      this.sendCodeStatus,
      () => api.PostAuthSendVerificationCode(params),
      (e) => {
        this.sendCodeData = e
        message.success(i18n.t("auth.code_sent"));
      },
      i18n.t("auth.send_code_failed"),
      (e) => {}
    );
  };

  login = async (params: PostAuthLoginParameters) => {
    await handleRequest(
      this.loginStatus,
      () => api.PostAuthLogin(params),
      () => {
        this.loggedIn = true;
        message.success(i18n.t("auth.login_success"));
      },
      i18n.t("auth.login_failed")
    );
  };

  logout = async () => {
    await handleRequest(
      this.logoutStatus,
      () => api.PostAuthLogout(),
      () => {
        this.loggedIn = false;
      },
      i18n.t("auth.logout_failed")
    );
  };
}

const authStore = new AuthStore();
export default authStore;
